/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiCSVRowsFromJSON(json) {
    return ApiCSVRowsFromJSONTyped(json, false);
}
export function ApiCSVRowsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rows': !exists(json, 'rows') ? undefined : json['rows'],
        'table': !exists(json, 'table') ? undefined : json['table'],
    };
}
export function ApiCSVRowsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'rows': value.rows,
        'table': value.table,
    };
}
